
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M19 4a1 1 0 01-.848.988l-5.004 12.874c.088.062.171.13.248.206L20 14.026V14a1 1 0 11.522.879l-6.607 4.043a2 2 0 01-3.817 1.198l-5.202.325a1 1 0 11-.063-.998l5.203-.325a2 2 0 01.72-1.189L5.896 6.995a1 1 0 11.914-.407l4.861 10.939a2.024 2.024 0 01.541-.016l5.01-12.885A1 1 0 1119 4z"}})])
          )
        }
      }
    